import axios from 'axios';
import { createAsyncThunk, createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { normalizeWallboardSnapshot, } from '../model/wallboard.model';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const apiUrl = API_ROUTES.qstat.wallboard;
const initialState = {
    loading: false,
    errorMessage: null,
    snapshot: null,
    lastUpdated: null,
};
export const getWallboardSnapshot = createAsyncThunk('wallboard/fetch_snapshot', async () => axios.get(apiUrl), { serializeError: serializeAxiosError });
export const wallboardSlice = createSlice({
    name: 'wallboard',
    initialState: initialState,
    reducers: {
        clearWallboard(state) {
            state.snapshot = null;
            state.errorMessage = null;
            state.lastUpdated = null;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getWallboardSnapshot.fulfilled, (state, action) => {
            state.loading = false;
            state.snapshot = normalizeWallboardSnapshot(action.payload.data);
            state.lastUpdated = new Date().toISOString();
            state.errorMessage = null;
        })
            .addMatcher(isPending(getWallboardSnapshot), (state) => {
            state.loading = true;
            state.errorMessage = null;
        })
            .addMatcher(isRejected(getWallboardSnapshot), (state, action) => {
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { clearWallboard } = wallboardSlice.actions;
export default wallboardSlice.reducer;
